import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { Button, Carousel, Modal } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import UserRoleType from "../routes/app/enums/UserRoleType";
import INTRO_KEYS from "../constants/IntroKeys";
import { useAppDispatch, useAppSelector } from "../store";
import { loggedInUserSelector } from "../store/slice/auth";
import { watchGettingStartedIntro, watchGettingStartedIntroSelector } from "../store/slice/settings";
const IntroCarouselSlide = ({ imgFileName, text }) => (_jsxs("div", { className: "intro-slide", children: [_jsx("img", { src: `assets/images/intro/${imgFileName}` }), _jsx("p", { children: text })] }));
const slideContent = {
    [INTRO_KEYS.DMS]: [{
            imgFileName: "dms-intro-1.png",
            text: "SubTrux is a revolutionary real time Delivery Management System that gives businesses the ability to take control of their complex delivery needs, create a genuine competitive advantage and realise their full potential."
        }, {
            imgFileName: "dms-intro-2.png",
            text: "Whether your business is big or small, there are a number of different packages to suit your needs and budget."
        }, {
            imgFileName: "dms-intro-3.png",
            text: "It’s easy to use and all of the functions are self explanatory. There are video how to guides across the platform. We are also available to guide you every step of the way. Start with a trial and upgrade any time."
        }],
    [INTRO_KEYS.MARKETPLACE]: [{
            imgFileName: "marketplace-intro-1.png",
            text: "Welcome to Subtrux marketplace. Whether you need vehicles for the day, week or month OR you are looking to hire a vehicle for a single job, SubTrux Marketplace gives you free access to a network of drivers with vehicles who are ready to deliver in real-time."
        }, {
            imgFileName: "marketplace-intro-2.png",
            text: "You can also download our Subtrux marketplace app on Android Playstore and Apple App Store to use on mobile devices."
        }, {
            imgFileName: "marketplace-intro-3.png",
            text: "It’s easy to use and all of the functions are self explanatory. There are video how to guides across the platform. We are also available to guide you every step of the way. Start sending now."
        }],
    [INTRO_KEYS.CONTRACTOR]: [{
            imgFileName: "marketplace-intro-1.png",
            text: "Welcome to SubTrux Marketplace where you can find an array of opportunities for work that suit your availability, capacity and resources. Dubbed the Uber of the courier industry, SubTrux Marketplace provides a source of income to anyone credible with a Ute, truck or suitable vehicle and the desire to work, creating new courier jobs for those who need it most."
        }, {
            imgFileName: "marketplace-intro-2.png",
            text: "Free to sign up and free to use, you will find unlimited job opportunities and truly enjoy the simplicity of the app. Full visibility is ensured for the job-poster and contractor, through refined mechanics of tracking, live imagery, and journey mapping from start to finish."
        }, {
            imgFileName: "marketplace-intro-3.png",
            text: "Important note: When you enter your driver (this is you and your drivers) details in your profile, enter the user name different to your email address as this is the log in for the driver app. " +
                "You will then receive an email to create your password for your driver app. Ensure you enter your vehicle details and driver details to enable you to log in to the driver app. That's all for now. Happy driving!"
        }]
};
const GettingStartedIntroCarousel = () => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const watchIntro = useAppSelector(watchGettingStartedIntroSelector);
    const [showIntroKey, setShowIntroKey] = useState(undefined);
    const [showModal, setShowModal] = useState(false);
    const [currentSlideIdx, setCurrentSlideIdx] = useState(0);
    const carouselRef = useRef(null);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (watchIntro && !showIntroKey && loggedInUser && loggedInUser.roles) {
            const firstRoleWithIntroKey = loggedInUser.roles.find((roleName) => {
                const roleEnum = UserRoleType.valueOf(roleName);
                return roleEnum && roleEnum.gettingStartedIntroKey;
            });
            if (firstRoleWithIntroKey) {
                const roleEnum = UserRoleType.valueOf(firstRoleWithIntroKey);
                if (roleEnum && roleEnum.gettingStartedIntroKey) {
                    setShowModal(true);
                    setShowIntroKey(roleEnum.gettingStartedIntroKey);
                    setCurrentSlideIdx(0);
                }
            }
        }
    }, [loggedInUser, watchIntro]);
    const onPrevClicked = () => {
        carouselRef.current?.prev();
    };
    const onNextClicked = () => {
        carouselRef.current?.next();
    };
    const onClose = () => {
        setShowModal(false);
    };
    const afterClose = () => {
        setShowIntroKey(undefined);
        setShowModal(false);
        dispatch(watchGettingStartedIntro(false));
    };
    if (showIntroKey) {
        const lastSlideIdx = slideContent[showIntroKey].length - 1;
        return (_jsx(Modal, { open: showModal, closable: false, destroyOnHidden: true, afterClose: afterClose, footer: null, children: _jsxs("div", { className: "intro-carousel-modal", children: [_jsx(Carousel, { ref: carouselRef, afterChange: setCurrentSlideIdx, children: slideContent[showIntroKey].map((slide, idx) => {
                            const text = (idx === 0 && loggedInUser) ? _jsxs("span", { children: ["Hi ", loggedInUser.firstName, ",", _jsx("br", {}), slide.text] }) : slide.text;
                            return (_jsx(IntroCarouselSlide, { imgFileName: slide.imgFileName, text: text }));
                        }) }), _jsxs("div", { className: "intro-carousel-buttons", children: [currentSlideIdx > 0 && _jsx(Button, { shape: "circle", size: "large", type: "default", className: "", onClick: onPrevClicked, children: _jsx(LeftOutlined, {}) }, "prev"), currentSlideIdx < lastSlideIdx && _jsx(Button, { shape: "circle", size: "large", type: "primary", className: "pull-right", onClick: onNextClicked, children: _jsx(RightOutlined, {}) }, "next"), currentSlideIdx === lastSlideIdx && _jsx(Button, { size: "large", type: "primary", className: "pull-right", onClick: onClose, children: "LET'S BEGIN" }, "next")] })] }) }));
    }
    return null;
};
export default GettingStartedIntroCarousel;
